import { cn } from "@/shared/lib/utils";

/**
 * Shared column template for the admin users table so the header, the data
 * rows, and the loading skeleton stay aligned.
 *
 * Tiers:
 *   base: Name | Status
 *   sm:   + Email
 *   lg:   + Role + Created
 */
export const GRID_TEMPLATE = cn(
  "grid-cols-[minmax(0,2fr)_auto]",
  "sm:grid-cols-[minmax(0,2fr)_minmax(0,2fr)_auto]",
  "lg:grid-cols-[minmax(0,2fr)_minmax(0,2fr)_auto_auto_auto]",
);

/** Subgrid span for the clickable row link across every column. */
export const ROW_LINK_SPAN = "col-span-2 sm:col-span-3 lg:col-span-5";
